"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const formik_1 = require("formik");
const RenderSelectField_1 = __importDefault(require("./RenderSelectField"));
const icons_1 = require("@material-ui/icons");
const core_1 = require("@material-ui/core");
const icons_2 = require("@material-ui/icons");
const RenderEdithTextField_1 = __importDefault(require("./RenderEdithTextField"));
const moment_1 = __importDefault(require("moment"));
const useStyles = core_1.makeStyles(() => ({
    editRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '2rem',
        alignItems: 'end',
    },
    select: {
        width: '8rem',
    },
    text: {
        width: '20.6rem',
    },
    dialog: {},
    deleteButton: {
        backgroundColor: 'white',
        minWidth: '34px',
        paddingLeft: '0px',
        paddingRight: '0px',
        alignSelf: 'center',
    },
    addItemBtn: {
        backgroundColor: '#F0F2F5',
    },
}));
const ModalHistory = (props) => {
    const editOptions = [
        {
            label: 'Proponent',
            value: 'Proponent',
            disabled: false,
        },
        {
            label: 'Review Comments Due',
            value: 'Review Comments Due',
            disabled: false,
        },
        {
            label: 'Proponent Responses Due',
            value: 'Proponent Responses Due',
            disabled: false,
        },
        {
            label: 'Item Description',
            value: 'Item Description',
            disabled: false,
        },
        {
            label: 'Documents for review',
            value: 'Documents for review',
            disabled: false,
        },
    ];
    const [editOptionsState, setEditOptionsState] = react_1.useState(editOptions);
    const classes = useStyles();
    const { isVisible, modalText, titleText, cancelText, confirmText, onCancel, onConfirm, validationSchema, onPost, reviewId, setEditHistoryField, } = props;
    const [editList, setEditList] = react_1.useState([
        { header: '', description: '', id: Math.random() + 10, idDes: Math.random() + 10 },
    ]);
    const formRef = react_1.useRef(null);
    react_1.useEffect(() => { }, [editList]);
    const addEditItem = (initialValues) => {
        setEditList([...editList, { header: '', description: '', id: Math.random() + 10, idDes: Math.random() + 10 }]);
    };
    const removeEditItem = (event, index) => {
        if (editList.length - 1 !== 0) {
            if (editList[index].header !== '') {
                for (const editItem of editOptionsState) {
                    if (editItem.value === editList[index].header) {
                        editItem.disabled = false;
                    }
                }
            }
            editList.splice(index, 1);
            //initialValues.values.splice(index, 1);
            setEditList([...editList]);
            setEditOptionsState([...editOptionsState]);
        }
    };
    const onSelectChange = (value, index) => {
        if (editList[index].header !== '') {
            for (const editItem of editOptionsState) {
                if (editItem.value === editList[index].header) {
                    editItem.disabled = false;
                }
            }
        }
        editList[index].header = value;
        for (const editItem of editOptionsState) {
            if (editItem.value === value) {
                editItem.disabled = true;
            }
        }
        setEditOptionsState([...editOptionsState]);
        setEditList([...editList]);
    };
    const handleSubmit = async (values) => {
        const currentLocalTime = new Date();
        const mstTime = new Date(currentLocalTime.toLocaleString('en-US', { timeZone: 'America/Denver' }));
        const EditedAt = moment_1.default(mstTime).format('YYYY-MM-DD HH:mm:ss.SSS');
        setEditHistoryField(editList, EditedAt);
        await onPost(reviewId, editList, EditedAt);
        await onConfirm();
    };
    const onTextChange = (event, index) => {
        event.preventDefault();
        editList[index].description = event.target.value;
        setEditList([...editList]);
    };
    const setFieldTouched = (index, initialValues) => {
        if (initialValues.editList1[index]) {
            initialValues.editList1[index].touched = true;
        }
    };
    return (react_1.default.createElement("div", { className: classes.dialog },
        react_1.default.createElement(Dialog_1.default, { open: isVisible, onClose: onCancel, fullWidth: true, maxWidth: "sm" },
            titleText && (react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(DialogTitle_1.default, null,
                    react_1.default.createElement(Box_1.default, null,
                        react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, titleText))),
                react_1.default.createElement(Divider_1.default, null))),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(formik_1.Formik, { innerRef: formRef, initialValues: {
                    editList1: editList,
                }, validationSchema: validationSchema, onSubmit: (initialValues) => handleSubmit(initialValues), enableReinitialize: true }, ({ initialValues, submitForm, errors }) => (react_1.default.createElement(formik_1.Form, null,
                react_1.default.createElement(DialogContent_1.default, null,
                    react_1.default.createElement(Box_1.default, null,
                        react_1.default.createElement("p", null, "Select the modified field and provide an explanation for the edit"),
                        editList.map((item, index) => {
                            return (react_1.default.createElement(Box_1.default, { className: classes.editRow, key: item.idDes || index + Math.random() },
                                react_1.default.createElement(formik_1.Field, { key: item.id, className: classes.select, name: item.id, label: "Edited field", options: editOptionsState, onValueChange: (value, event) => onSelectChange(value, index), component: RenderSelectField_1.default, value: item.header !== '' ? item.header : '', onClick: () => setFieldTouched(index, initialValues) }),
                                react_1.default.createElement(Box_1.default, null,
                                    react_1.default.createElement(Typography_1.default, { style: { marginLeft: '0.4rem' } }, "was updated because"),
                                    react_1.default.createElement(formik_1.FastField, { component: RenderEdithTextField_1.default, name: item.idDes, label: "Edit Reason", className: classes.text, onBlur: (event) => onTextChange(event, index), defaultValue: item.description ? item.description : '' })),
                                react_1.default.createElement(Typography_1.default, { style: { alignSelf: 'flex-end', fontWeight: 'bolder' } }, "."),
                                react_1.default.createElement(Button_1.default, { variant: "contained", color: "secondary", onClick: (event) => removeEditItem(event, index), className: classes.deleteButton },
                                    react_1.default.createElement(icons_1.Delete, null))));
                        })),
                    react_1.default.createElement(Button_1.default, { onClick: (initialValues) => addEditItem(initialValues), startIcon: react_1.default.createElement(icons_2.AddCircleOutline, null), className: classes.addItemBtn }, "Add Edit Item")),
                react_1.default.createElement(DialogActions_1.default, null,
                    cancelText && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "secondary", onClick: onCancel, style: { maxHeight: '30px', minWidth: '160px' } }, cancelText)),
                    confirmText && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: () => submitForm(), style: { maxHeight: '30px' } }, confirmText)))))))));
};
ModalHistory.propTypes = {
    isVisible: prop_types_1.default.bool.isRequired,
    modalText: prop_types_1.default.any,
    titleText: prop_types_1.default.string,
    cancelText: prop_types_1.default.string,
    confirmText: prop_types_1.default.string,
    onCancel: prop_types_1.default.any,
    validationSchema: prop_types_1.default.any,
    onConfirm: prop_types_1.default.any,
    onPost: prop_types_1.default.any,
    reviewId: prop_types_1.default.string,
    setEditHistoryField: prop_types_1.default.any,
};
exports.default = ModalHistory;
